// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label_page[data-v-2dd87b61]{font-size:.18rem;font-weight:400;color:#666;line-height:.23rem;padding-top:.2rem}.label_page .page_title[data-v-2dd87b61]{font-size:.2rem;margin:0 .23rem 0 .15rem;position:relative}", ""]);
// Exports
module.exports = exports;
